// extracted by mini-css-extract-plugin
export default {"fr-view":"Pin_fr-view__troFE","pin":"Pin_pin__F50T0","delete":"Pin_delete__nLkLc"};